import * as Sentry from '@sentry/browser';

// GlitchTip / Sentry — inicjalizacja SDK frontu.
// VITE_SENTRY_DSN trafia do bundla w czasie buildu — pusty DSN = SDK wyłączony.
if (import.meta.env.VITE_SENTRY_DSN) {
    const releaseMeta = document.querySelector('meta[name="app-version"]');
    const appRelease = releaseMeta ? releaseMeta.getAttribute('content') : undefined;

    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'production',
        release: appRelease,
        autoSessionTracking: false,        // GlitchTip nie wspiera
        tracesSampleRate: 0,                // performance off
        sendDefaultPii: false,
        denyUrls: [
            /extensions\//i,
            /^chrome:\/\//i,
            /^moz-extension:\/\//i,
            /^safari-extension:\/\//i,
        ],
        ignoreErrors: [
            'ResizeObserver loop limit exceeded',
            'ResizeObserver loop completed with undelivered notifications',
            'Non-Error promise rejection captured',
            'NetworkError when attempting to fetch resource',
            'AbortError',
            /Request failed with status code 419/,
            /CSRF token mismatch/,
            /^Script error\.?$/,
        ],
        integrations: [
            Sentry.breadcrumbsIntegration({ console: false }),
        ],
    });

    // User context z meta tagu (renderowanego po stronie Blade dla zalogowanych userów).
    const userMeta = document.querySelector('meta[name="sentry-user"]');
    if (userMeta) {
        try {
            Sentry.setUser(JSON.parse(userMeta.getAttribute('content')));
        } catch (e) {
            // malformed meta — ignore
        }
    }

    window.Sentry = Sentry;
}

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo/Pusher - Real-time Broadcasting (opcjonalny)
 *
 * Pusher jest wyłączony domyślnie. Aby włączyć:
 * 1. Odkomentuj zmienne PUSHER_* i VITE_PUSHER_* w .env
 * 2. Ustaw BROADCAST_CONNECTION=pusher w .env
 * 3. Uruchom: npm run build
 */

// Inicjalizuj Echo tylko gdy Pusher jest skonfigurowany
const pusherKey = import.meta.env.VITE_PUSHER_APP_KEY;
const pusherCluster = import.meta.env.VITE_PUSHER_APP_CLUSTER;

if (pusherKey && pusherCluster) {
    import('laravel-echo').then((EchoModule) => {
        import('pusher-js').then((PusherModule) => {
            const Echo = EchoModule.default;
            const Pusher = PusherModule.default;

            window.Pusher = Pusher;

            window.Echo = new Echo({
                broadcaster: 'pusher',
                key: pusherKey,
                cluster: pusherCluster,
                forceTLS: true,
                authEndpoint: '/broadcasting/auth',
                auth: {
                    headers: {
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content
                    }
                }
            });

            console.log('Pusher/Echo initialized');
        });
    });
} else {
    // Pusher wyłączony - nie inicjalizuj Echo
    window.Echo = null;
    console.log('Pusher disabled - real-time broadcasting not available');
}
